import { AlertMessage } from '@brighterion/br-ui';
import React from 'react';
import { ALERT_BANNER_DURATION_DEFAULT, callAll } from 'Utils';
import NoNetworkBanner from './NoNetworkBanner';
import styles from './AlertBanners.css';

type Props = {
    alerts: AlertProp[];
    defaultOnClose: (id: string | number) => void;
};

function Banner({ alert, closeAlert }: { alert: AlertProp; closeAlert: () => void }) {
    const { status, content } = alert;

    React.useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;

        if (alert.status === 'success') {
            timeout = setTimeout(() => {
                closeAlert();
            }, alert.duration || ALERT_BANNER_DURATION_DEFAULT);
        }

        return () => {
            clearTimeout(timeout);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div data-testid={`alertwrapper-${alert.id}`}>
            <AlertMessage dataTestId={`${alert.id}`} type={status as any} closeAlert={closeAlert} isOpen>
                <>{content}</>
            </AlertMessage>
        </div>
    );
}

function AlertBanners({ alerts, defaultOnClose }: Props) {
    return (
        <div data-testid='alert-banners' className={styles.alertsContainer}>
            <NoNetworkBanner />
            {/* only want to show the first five and as they dismiss, the array will be updated */}
            {alerts.slice(0, 5).map((alert) => {
                const { id, onClose } = alert;
                const handleClose = callAll(defaultOnClose, onClose);

                return <Banner key={id} alert={alert} closeAlert={() => handleClose(id)} />;
            })}
        </div>
    );
}

export default AlertBanners;
